import React, { useMemo, useState } from 'react';

import {
  SidePage,
  Stack,
  Divider,
  Actions,
  Action,
  VirtualizedList,
  Table,
  TableHead,
  TableCell,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import {
  TagFormCreate,
  TagFormUpdate,
} from 'scenes/Gallery/ConversionPages/ConversionPages/TagForm';
import { useLoadTags } from 'scenes/Gallery/ConversionPages/ConversionPages/data';

import SearchField from './SearchField';
import TagActions from './Actions';

const Tags = ({ onClose, onExited, open }) => {
  const [childComponent, openChildComponent] = useChildComponent();
  const [searchQuery, setSearchQuery] = useState('');

  const { data, isLoading, isRefetching } = useLoadTags();

  const filteredData = useMemo(() => {
    if (!data) {
      return [];
    }
    const queryKey = searchQuery.toUpperCase();
    return searchQuery.length
      ? data.filter(({ name }) => name.toUpperCase().includes(queryKey))
      : data;
  }, [data, searchQuery]);

  const handleAddTag = () => {
    openChildComponent(TagFormCreate);
  };

  const handleEdit = ({ id, name }) => {
    openChildComponent(TagFormUpdate, {
      id,
      name,
    });
  };

  return (
    <SidePage
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isRefetching}
      open={open}
      size={'md'}
    >
      <SidePage.Title title={'Tags'} />
      <SidePage.NewBody fullHeight={false} scroll={false}>
        <Stack spacing={2} direction={'row'}>
          <Stack flex={1}>
            <SearchField onChange={setSearchQuery} />
          </Stack>
          <Actions>
            <Action
              border={true}
              button={true}
              add={true}
              iconContent={true}
              tooltip={'Add Tag'}
              variant={'outlined'}
              onClick={handleAddTag}
            />
          </Actions>
        </Stack>
      </SidePage.NewBody>
      <Divider />
      <SidePage.NewBody disableGutters dense scroll={false}>
        <Table>
          <TableHead>
            <TableCell width={'87%'}>Name</TableCell>
            <TableCell width={'13%'}>Actions</TableCell>
          </TableHead>
        </Table>
        <VirtualizedList
          data={filteredData}
          button={false}
          withSearch={!!searchQuery}
          actionCount={2}
          secondaryAction={(item) => {
            return <TagActions data={item} onEdit={handleEdit} />;
          }}
        />
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
      {childComponent}
    </SidePage>
  );
};

export default Tags;
